<template>
  <div>

    <div v-if="!InTriggerEditor && !InOnboardingEditor && !InWorkflowEditor">
      Step: {{CurrentStep}} of 3<br />
      <div v-if="CurrentStep == 1">
        <input type="text" v-model="Title" placeholder="Title" style=" font-size: 20px; font-weight: 100; border: 0px; margin-top: 20px; margin-left: 20px;" /><br/>
        <tiptap v-model="Content" ref="tiptap" :HideEditorToolBar="true" style="height:450px;"></tiptap>
      </div>
      <div v-if="CurrentStep == 2">
        <br />
        <h3>
          Onboarding options:
        </h3>
        <br />
        Bellow you can change the triggers and options for this step.
        <table style="width:100%; margin-top:20px;">
          <tr>
            <th style="vertical-align:top">
              Trigger
            </th>
            <!--<th style="vertical-align:top">Users:</th>-->
            <th style="width:50%; vertical-align:top;">Workflow:</th>
            <th style="vertical-align:top">Onboarding:</th>
          </tr>
          <tr>
            <td style="vertical-align: top; word-break: break-all;">
              Page {{Operator}}<br /><strong>{{Trigger}}</strong><br />
              <a @click="InTriggerEditor = true">change</a>
            </td>
            <!--<td valign="top" style="vertical-align:top">
            Everyone who have not been onboarded in the last 5 months
          </td>-->
            <td class="skill-name-cell" style="vertical-align:top">
              <span v-if="Workflow">{{Workflow.name}}</span><br />
              <a @click="InWorkflowEditor = true">Change</a>
            </td>
            <td valign="top" style="vertical-align:top">
              <span v-if="Onboarding">{{Onboarding.name}}</span><br />
              <a @click="InOnboardingEditor = true">change</a>
            </td>
          </tr>
        </table>
      </div>
      <div style="position:absolute; bottom:0px;">
        <vs-button v-if="CurrentStep < 3" size="small"
                   class="mr-3 bg-success" @click="CurrentStep += 1">
          I am done >>
        </vs-button>
        <vs-button v-else size="small" class="mr-3 bg-success" @click="SaveOnboardingStep">
          Save
        </vs-button>
      </div>
    </div>

    <TriggerEditor v-if="InTriggerEditor" :TriggerUrl="TriggerUrl" @OnTriggerChanged="OnTriggerChanged">

    </TriggerEditor>

    <OnboardingEditor v-if="InOnboardingEditor" :Onboardings="Onboardings" @OnboardingChanged="OnOnboardingChanged"></OnboardingEditor>

    <WorkflowEditor v-if="InWorkflowEditor" :Workflows="Workflows" @OnWorkflowChanged="OnWorkflowChanged"></WorkflowEditor>

  </div>

</template>

<script>

  import tiptap from "@/views/components/extra-components/editors/tiptap.vue";
  import FeatherIcon from "@/components/FeatherIcon.vue";
  import TriggerEditor from "@/views/components/onboarding-skills/TriggerEditor.vue";
  import OnboardingEditor from "@/views/components/onboarding-skills/OnboardingEditor.vue";
  import WorkflowEditor from "@/views/components/onboarding-skills/WorkflowEditor.vue";
  import TCVelikClient from '@/TCVelikClient/TCVelikClient';

  export default {
    name: "AddEditAddressView",
    data() {
      return {
        Trigger: "",
        Title: "",
        Content: "",
        OnboardingId: "",
        CurrentStep: 1,
        InTriggerEditor: false,
        Operator: "EQUALS",
        InOnboardingEditor: false,
        InWorkflowEditor: false,
        Onboarding: null,
        Workflow: null
      };
    },
    mounted() {
      this.$refs.tiptap.$el.focus();
      this.Trigger = this.TriggerUrl;
    },
    methods: {
      OnTriggerChanged(updateObject) {
        this.Trigger = updateObject.Trigger;
        this.Operator = updateObject.Operator;
        this.InTriggerEditor = false;
      },
      OnOnboardingChanged(args) {
        this.Onboarding = args.Onboarding;
        this.InOnboardingEditor = false;
      },
      OnWorkflowChanged(args) {
        this.Workflow = args.Workflow;
        this.InWorkflowEditor = false;
      },
      SaveOnboardingStep() {
        var req = JSON.stringify({

          // TODO: If we have PMF - properly parametrize this to use variables instead string interpolations / replace.
          query: `mutation AddOnboardingStep() {
                    addOnboardingStep(
                        entity: {
                            id: 0,
                            title:"${this.Title.replace(/"/g, '\\"')}"
                            content:"${this.Content.replace(/"/g, '\\"')}"
                            onboardingStepsCriterias: [{
                              id: 0
                              operator: "${this.Operator}"
                              value: "${this.Trigger.replace(/"/g, '\\"')}"
                            }]
                            workflowId: ${this.Workflow.id}
                        }
                        parentID: ${this.Onboarding.id}
                    ) {
                        id
                        title
                        onboardingId
                        content
                    }
                }`});

        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response && response.data && response.data.data) {
            alert('Great job, thanks!');
          }
          else if (response && response.data && response.data.errors) {
            alert('There were some errors saving :(');
          }
        });
      }
    },
    props: ["TriggerUrl", "Onboardings", "Workflows"],
    components: { FeatherIcon, tiptap, TriggerEditor, OnboardingEditor, WorkflowEditor }
  }
</script>

<style>

  .btn {
    background: none;
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 10px;
    cursor: pointer;
    margin-left: 5px;
  }

  .btn-danger {
    background-color: indianred;
    border: 1px solid indianred;
    color: white;
  }

  .btn-success {
    background-color: #349539;
    border: 1px solid #349539;
    color: white;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    border: 0px solid white;
  }

  th, td {
    border-bottom: 1px solid #ccc;
    padding: 8px;
    text-align: left;
    vertical-align: bottom;
    max-width: 50px !important;
    width: 50px !important;
  }

    th.skill-name-cell, td.skill-name-cell {
      max-width: unset !important;
      width: unset !important;
    }

  th {
    vertical-align: top;
    font-weight: bold;
  }

  .employee-header div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .employee-header span {
    transform: rotate(-90deg);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    /*margin-bottom: 40px;*/
    font-weight: 900;
  }

  .avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    margin-bottom: 5px;
    /*margin-top: 20px;*/
    margin-left: 0px;
    display: block;
    /*border: 5px solid green;*/
    margin-right: 5px;
  }

  h1 {
    font-weight: 900;
    /*margin-top: 2em;*/
  }

  .completed {
    border: 5px solid green;
  }

  .in-progress {
    border: 5px solid orange;
  }

  .not-started {
    border: 5px solid gray;
  }

  .add-div {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    text-align: center;
    border: 1px solid green;
    color: green;
    padding-top: 2px;
    padding-left: 1px;
    cursor: pointer;
    font-size: 2em;
    font-weight: 100;
  }

  .skill-cell {
    border-radius: 50%;
    width: 24px;
    height: 24px;
    cursor: pointer;
  }

    .skill-cell.current {
      animation: blink 2s infinite; /* Run the animation indefinitely with a duration of 2 seconds */
    }

  tr.faded {
    /*opacity:0.3;*/
    display: none;
  }

  @keyframes blink {
    0%, 100% {
      opacity: 1; /* Fully visible at the start and end */
    }

    50% {
      opacity: 0; /* Fully invisible in the middle */
    }
  }


  .accordion {
    width: 100%;
  }

  .accordion-item {
    border-bottom: 1px solid #ccc;
  }

  .accordion-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    padding: 10px;
  }

  .employee-icons {
    display: flex;
  }

  .avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 5px;
  }

  .add-icon {
    font-size: 24px;
    font-weight: bold;
  }

  .accordion-content {
    display: none;
    padding: 10px;
    background-color: #f9f9f9;
  }

  .status-dot {
    height: 25px;
    width: 25px;
    border-radius: 50%;
    display: inline-block;
  }

  .skill-status {
    display: flex;
    justify-content: space-around;
    padding-top: 10px;
  }
</style>
